// extracted by mini-css-extract-plugin
export var actionIcon = "_n8-0";